// Custom Styles with Light Indigo & Subtle Accents
export const DataStyles = {
  table: {
    style: {
      borderRadius: '0.5rem',
      border: '1px solid #e0e7ff', // Light Indigo border
      overflow: 'hidden',
    },
  },
  headRow: {
    style: {
      backgroundColor: '#eef2ff', // Very light indigo (Tailwind: indigo-50)
      borderBottom: '1px solid #d1d5db', // gray-300
    },
  },
  headCells: {
    style: {
      color: '#4338ca', // Tailwind: indigo-700
      fontWeight: '600',
      fontSize: '14px',
      textTransform: 'uppercase',
      paddingTop: '14px',
      paddingBottom: '14px',
    },
  },
  rows: {
    style: {
      fontSize: '14px',
      color: '#374151', // gray-700
      backgroundColor: '#fff',
      minHeight: '48px',
      borderBottom: '1px solid #f3f4f6',
      transition: 'all 0.2s ease-in-out',
      '&:hover': {
        backgroundColor: '#f3f4f6',
        transform: 'scale(1.01)',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
      },
    },
  },
  pagination: {
    style: {
      borderTop: '1px solid #e5e7eb',
      padding: '16px',
      fontSize: '14px',
      color: '#4b5563',
    },
  },
};
